module.exports = __webpack_public_path__ + "static/img/school-logo.4ee82b2f.png";